/**
 *
 *
 * @author Jaap
 * @date 23-09-2019
 */
export default class PostForm {
    postForm(formData, apiCall, requestMethod) {
        // Set up our HTTP request
        let xhr = new XMLHttpRequest();

        // Return it as a Promise
        return new Promise(function (resolve, reject) {
            // Setup our listener to process completed requests
            xhr.onreadystatechange = function () {
                // Only run if the xhr is complete
                if (xhr.readyState !== 4) return;

                // Process the response
                if (xhr.status >= 200 && xhr.status < 300) {
                    // If successful
                    resolve(xhr);
                } else {
                    // If failed
                    reject({
                        status: xhr.status,
                        statusText: xhr.statusText,
                    });
                }
            };

            // Setup our HTTP request

            requestMethod = requestMethod || "POST";
            xhr.open(requestMethod, apiCall);
            xhr.send(formData);
        });
    }

    bindForm() {
        //bind field blur
        this.formElement.querySelectorAll("[data-validator]").forEach((entry) => {
            entry.addEventListener("blur", this.validateFieldByEvent.bind(this));
        });
        //bind form submit
        this.formElement.addEventListener("submit", this.submitForm.bind(this));
    }

    validateFieldByEvent(event) {
        return this.validateField(event.currentTarget);
    }

    validateField(element) {
        let valid = true;
        if (element.dataset.validator) {
            let validators = element.dataset.validator.split(";"),
                val = this.getFieldValue(element);
            valid = validators.every((validator) => {
                switch (validator.trim()) {
                    case "notEmpty":
                        return val && val.length > 0;
                    case "email":
                        return /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/i.test(val);
                }
            });
        }

        if (valid) {
            element.classList.remove("error");
        } else {
            element.classList.add("error");
        }

        return valid;
    }

    getFieldValue(field) {
        switch (field.nodeName.toLowerCase()) {
            case "input":
            case "textarea":
                return field.value;
        }
        return false;
    }

    postSuccess() {
        this.formElement.dataset["submitted"] = "success";
    }

    postError() {
        this.formElement.dataset["submitted"] = "failed";
    }
}
